// extracted by mini-css-extract-plugin
export default {"summary":"GeneralAccordion_summary__8HQ0a","summaryContent":"GeneralAccordion_summaryContent__WJWzW","detailContent":"GeneralAccordion_detailContent__Uw9fC"};